import { motion } from "framer-motion";
import WhaleLogo from "./WhaleLogo";
import { SUPPLY } from "../lib/constants";

const reveal = {
  initial: { y: 36, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount: 0.15 },
};

const Card = ({ children, className = "", delay = 0, testid }) => (
  <motion.div
    data-testid={testid}
    {...reveal}
    transition={{ ...reveal, delay }}
    className={`sticker rounded-3xl p-7 sm:p-8 ${className}`}
  >
    {children}
  </motion.div>
);

export default function Tokenomics() {
  return (
    <section id="tokenomics" data-testid="tokenomics-section" className="relative py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div {...reveal} className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-ocean-cyan">
            Token Details
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
            Whale-sized numbers.
          </h2>
          <p className="mt-3 text-base font-medium text-ocean-muted sm:text-lg">
            One billion tokens. Zero complications. That's the whole sheet.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          <Card testid="tokenomics-supply" delay={0} className="relative overflow-hidden bg-ocean-navy text-white lg:col-span-2" >
            <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-ocean-sky">
              Total Supply
            </p>
            <p
              data-testid="tokenomics-supply-value"
              className="mt-3 font-display text-5xl font-semibold tracking-tight sm:text-7xl"
            >
              {SUPPLY}
            </p>
            <p className="mt-2 font-display text-2xl font-medium text-ocean-yellow">
              $BLUE
            </p>
            <WhaleLogo className="absolute -bottom-6 -right-4 h-40 w-40 opacity-20" flip />
          </Card>

          <Card testid="tokenomics-ticker" delay={0.1} className="bg-ocean-yellow">
            <p className="text-xs font-extrabold uppercase tracking-[0.24em]">
              Ticker
            </p>
            <p className="mt-3 font-display text-6xl font-semibold sm:text-7xl">
              $BLUE
            </p>
          </Card>

          <Card testid="tokenomics-name" delay={0.15} className="bg-white">
            <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-ocean-muted">
              Name
            </p>
            <p className="mt-3 font-display text-4xl font-semibold sm:text-5xl">
              Bluewhale
            </p>
            <p className="mt-3 text-sm font-medium text-ocean-muted">
              The biggest animal on earth. Obviously.
            </p>
          </Card>

          <Card testid="tokenomics-utility" delay={0.2} className="bg-ocean-coral">
            <p className="text-xs font-extrabold uppercase tracking-[0.24em]">
              Utility
            </p>
            <p className="mt-3 font-display text-6xl font-semibold sm:text-7xl">
              None.
            </p>
            <p className="mt-3 text-sm font-semibold">
              And that's the point — it's a meme, not a promise.
            </p>
          </Card>

          <Card testid="tokenomics-narrative" delay={0.25} className="bg-ocean-sky">
            <p className="text-xs font-extrabold uppercase tracking-[0.24em]">
              Narrative
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              {["Bluewhale", "Ocean", "Community", "Memes"].map((t) => (
                <span
                  key={t}
                  className="sticker-sm rounded-full bg-white px-4 py-2 font-display text-sm font-semibold"
                >
                  {t}
                </span>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
